import React from "react";
import PhotoPreview from "../trips/detail/sections/PhotoPreview";
import styles from "./BillingFilePreviews.module.scss";

// Read-only thumbnails for the billing form's document sections (rate
// confirmation / proof of delivery). Reuses the trips PhotoPreview component:
// click a thumbnail to open the full file in a modal. Files come from the
// island's inline JSON props.
export default function BillingFilePreviews({ files = [] }) {
  if (!files.length) return null;
  return (
    <div className={styles.list}>
      {files.map((file) => (
        <div key={file.id} className={styles.item}>
          <PhotoPreview
            src={file.url}
            name={file.name}
            mimeType={file.mime_type}
            isImage={file.is_image}
            thumbClassName={styles.thumb}
          />
          <span className={styles.name} title={file.name}>
            {file.name || gettext("File")}
          </span>
        </div>
      ))}
    </div>
  );
}
